export var REFUNDS_LIST_PATH = '/refunds/';
